import { render, staticRenderFns } from "./Mam.vue?vue&type=template&id=2f98a728"
import script from "./Mam.vue?vue&type=script&lang=js"
export * from "./Mam.vue?vue&type=script&lang=js"
import style0 from "./Mam.vue?vue&type=style&index=0&id=2f98a728&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports